import React, { useEffect } from 'react';

import {
    Dialog, Slide,
} from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


export const DialogCustom = (props) => {


    useEffect(() => {
        if (props?.open === true) {
            window.location.hash += "#" + props.hashName;
        }

    }, [props?.open]);

    useEffect(() => {
        if (window.location.hash === "") {
            props?.onClose()
        }
    }, [window.location.hash]);

    return (
        <>
            <Dialog
                fullScreen
                TransitionComponent={Transition}
                onClose={() => {
                    props.onClose()
                }}
                open={props.open}

            >
                {
                    props.customContent
                }
            </Dialog>
        </>
    );
}